import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeInventoryIncidentActionAsync } from '../redux/actions/typeInventoryIncidentActions'

export const useTypeInventoryIncident = () => {
  const { typeInventoryIncidentState } = useSelector(
    (state: RootState) => state.typeInventoryIncident
  )
  const dispatch = useDispatch()

  const getTypeInventoryIncident = () => {
    dispatch(getTypeInventoryIncidentActionAsync())
  }

  return {
    typeInventoryIncidentState,

    getTypeInventoryIncident
  }
}
